export default __webpack_public_path__ + "static/plasma_cutting-f6637ee745d9ffe92007d1bef95e93c5.jpeg";